import { SenderTypeEnum, SmsTemplateCreateInterface } from '../types'

export const defaultSmsTemplateValues: SmsTemplateCreateInterface = {
  name: '',
  senderType: SenderTypeEnum.PhoneNumber,
  phoneNumber: null,
  alphanumericSender: null,
  messageServiceSid: null,
  content: '',
}
